import { render, staticRenderFns } from "./UserPlan.vue?vue&type=template&id=fac4fd46&scoped=true&"
import script from "./UserPlan.vue?vue&type=script&lang=js&"
export * from "./UserPlan.vue?vue&type=script&lang=js&"
import style0 from "./UserPlan.vue?vue&type=style&index=0&id=fac4fd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac4fd46",
  null
  
)

export default component.exports